import React, { useState, useEffect } from "react";

import { Form, Input, Button, message, Space, Select } from "antd";

import { FormOutlined } from "@ant-design/icons";

import { Http } from "../../Http";
import queryString from "query-string";

import styles from "./MediaSave.module.less";

const { TextArea } = Input;
const { Option } = Select;

function MediaSave({ navigate, location }) {
  const { state } = location;
  const { data, search, pagination } = state;

  const [submit, setSubmit] = useState(false);

  const [brands, setBrands] = useState([]);
  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });

  const [form] = Form.useForm();

  const onBack = () => {
    navigate("../", { state: { search, pagination } });
  };

  const getBrandList = async (params) => {
    try {
      let para = queryString.stringify({
        pageNumber: params.brandPagination.current,
        pageSize: params.brandPagination.pageSize,
      });
      let parsed = await Http.get(`brand`, {
        searchParams: para,
      }).json();
      if (parsed.state === "ok") {
        setBrands(parsed.result.list);
        setBrandPagination({
          current: parsed.result.pageNumber,
          pageSize: parsed.result.pageSize,
          total: parsed.result.totalRow,
        });
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
    }
  };

  const onFinish = async (values) => {
    setSubmit(true);
    if (data) {
      values = { ...data, ...values };
    }
    let para = queryString.stringify(values);
    try {
      let parsed = await Http.post(`media/save`, {
        body: new URLSearchParams(para),
      }).json();
      if (parsed.state === "ok") {
        await message.success(parsed.message ? parsed.message : "提交成功");
        onBack();
      } else {
        await message.warn(parsed.message ? parsed.message : "提交失败");
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setSubmit(false);
    }
  };

  useEffect(() => {
    getBrandList({ brandPagination });
    if (data) {
      form.setFieldsValue(data);
    }
  }, [data]);

  return (
    <div className={styles.MediaSave}>
      <div className={styles.header}>
        <FormOutlined style={{ fontSize: 16, color: "#1890ff" }} />
        <i>{data ? "数据编辑" : "新增数据"}</i>
      </div>
      <div className={styles.content}>
        <div className={styles.wrap}>
          <Form
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            form={form}
            onFinish={onFinish}
          >
            <Form.Item
              name="brandId"
              label="品牌"
              rules={[{ required: true, message: "请选择品牌!" }]}
            >
              <Select
                showSearch
                placeholder="请选择品牌"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {brands.map((value) => (
                  <Option value={value.id} key={value.id}>
                    {value.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="type"
              label="类型"
              rules={[{ required: true, message: "请选择类型!" }]}
            >
              <Select placeholder="请选择类型" allowClear>
                <Option value={1}>新闻</Option>
                <Option value={2}>贴吧</Option>
                <Option value={3}>知道</Option>
              </Select>
            </Form.Item>
            {data ? null : (
              <Form.Item
                name="value"
                label="链接"
                rules={[
                  {
                    required: true,
                    message: "请输入链接，一行一条！",
                  },
                ]}
              >
                <TextArea placeholder="请输入链接，一行一条！" rows={3} />
              </Form.Item>
            )}
            {data ? (
              <Form.Item
                name="title"
                label="标题"
                rules={[{ required: true, message: "请输入标题!" }]}
              >
                <Input
                  disabled={data?.status === 0 ? true : false}
                  placeholder="请输入标题"
                />
              </Form.Item>
            ) : null}
            {data ? (
              <Form.Item
                name="url"
                label="链接"
                rules={[{ required: true, message: "请输入链接!" }]}
              >
                <Input placeholder="请输入链接" />
              </Form.Item>
            ) : null}
            <Form.Item wrapperCol={{ offset: 4 }}>
              <Space>
                <Button
                  type="primary"
                  disabled={submit}
                  loading={submit}
                  htmlType="submit"
                >
                  提交
                </Button>
                <Button htmlType="button" onClick={onBack}>
                  返回
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default MediaSave;
